<div class="top-nav" *ngIf="sidebarNav">
  <a data-e2e="logo" class="brand" [ngClass]="{ 'show-on-scroll': isLogoBorderVisible }" routerLink="/">
    <i class="logo">
      <logo [isLightTheme]="isLightTheme"></logo>
    </i>
    <i class="logo mini">
      <logo [isLightTheme]="isLightTheme" [type]="logoTypes.COMPACT"></logo>
    </i>
  </a>

  <div #topNav class="nav-options" [class.has-upsell-enabled]="isUpsellVisible" [perfectScrollbar]="{ suppressScrollX: true }" (scroll)="onScroll($event)">
    <div *ngIf="showSidebarFilter" class="group-filter-container">
      <global-groups-multi-select-filter
        placeholder="Groups"
        [expandGroupsFilter]="isSideBarMaximized"
        [isDisabled]="groupsFilterDisabled$ | async"
        [disabledTooltipMessage]="groupsFilterDisabledTooltip"
        [fullWidth]="true"
        [alwaysShowCondensedMessage]="true"
        [footerThreshold]="1"
        i18n-placeholder
      ></global-groups-multi-select-filter>
    </div>
    <div class="ui secondary fluid vertical menu menu-container" [class.light-theme]="isLightTheme">
      <div *ngIf="!isAdminSidebar">
        <span
          *ngFor="let item of sidebarNav.navItems; let currentIndex = index"
          phx-tooltip
          [phxContent]="item.label"
          phxPlacement="right"
          phxTooltipSize="small"
          [phxTrigger]="isSideBarMaximized || showPopover ? 'none' : 'hover'"
        >
          <a
            class="fv-item item"
            phx-tooltip
            phxPlacement="right"
            [phxShowCloseIcon]="true"
            [phxContent]="popoverTemplate"
            phxTooltipOverlayClassName="notification-popover"
            [phxTooltipMaxWidth]="268"
            [phxTrigger]="showPopover && item.name === popover?.key ? 'always' : 'none'"
            [phxIntent]="popover?.intent || 'positive'"
            (phxTooltipCloseIconClicked)="popoverDismissed()"
            [routerLink]="item.link"
            [class.active]="currentIndex === currentActiveLinkIndex"
            [attr.data-e2e]="item.name"
            [target]="item.openInNewTab ? '_blank' : '_self'"
            (click)="onSidebarItemClick(item)"
          >
            <div class="icon-container fv-sidebar-icon">
              <i phx-icon [phxIcon]="phxIconNames[item.name]"></i>
            </div>
            <span class="link-text fv-sidebar-text phx-web-type-body-medium" title="{{ item.label }}">{{ item.label }}</span>
            <span *ngIf="item.isAlphaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>alpha</span>
            <span *ngIf="item.isBetaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>beta</span>
            <span *ngIf="item.isNewTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>new</span>
            <phx-badge *ngIf="item.count" class="counter-badge" phxSize="small" [phxCount]="item.count"></phx-badge>
            <span *ngIf="item.showNotificationDot" class="ui tiny circular label counter"></span>
          </a>
          <phx-divider
            *ngIf="
              currentIndex < sidebarNav.navItems.length - 1 &&
              item.dashboardDividerGroup !== sidebarNav.navItems[currentIndex + 1].dashboardDividerGroup
            "
            class="dasboard-divider"
          ></phx-divider>
        </span>
      </div>

      <div *ngIf="isAdminSidebar">
        <div *ngIf="adminNavItems[adminNavGroups.ORGANIZATION]?.length">
          <div
            class="d-flex align-items-center title justify-space-between nav-group active"
            (click)="accordionStateChange(adminNavGroups.ORGANIZATION)"
          >
            <span class="group-title" [title]="adminNavGroups.ORGANIZATION">{{ adminNavGroupsTitles[adminNavGroups.ORGANIZATION] }}</span>
            <phx-divider class="grey-80" phxMarginY="none"></phx-divider>
            <i
              phx-icon
              [phxIcon]="chevronDownIcon"
              size="16"
              [ngClass]="{
                rotate180: adminSidebarStates[adminNavGroups.ORGANIZATION],
                rotate0: !adminSidebarStates[adminNavGroups.ORGANIZATION]
              }"
            ></i>
            <phx-divider class="grey-80" phxMarginY="none"></phx-divider>
          </div>
          <div
            class="content p-0-imp"
            [class.close]="!adminSidebarStates[adminNavGroups.ORGANIZATION]"
            [class.open]="adminSidebarStates[adminNavGroups.ORGANIZATION]"
            data-key="organization"
          >
            <span
              *ngFor="let item of adminNavItems[adminNavGroups.ORGANIZATION]; let currentIndex = index"
              phx-tooltip
              [phxContent]="item.label"
              phxPlacement="right"
              phxTooltipSize="small"
              [phxTrigger]="isSideBarMaximized || showPopover ? 'none' : 'hover'"
            >
              <a
                class="fv-item item"
                phx-tooltip
                phxPlacement="right"
                [phxShowCloseIcon]="true"
                [phxContent]="popoverTemplate"
                phxTooltipOverlayClassName="notification-popover"
                [phxTooltipMaxWidth]="268"
                [phxTrigger]="showPopover && item.name === popover?.key ? 'always' : 'none'"
                [phxIntent]="popover?.intent || 'positive'"
                (phxTooltipCloseIconClicked)="popoverDismissed()"
                [routerLink]="item.isOutsideLink ? null : item.link"
                [class.active]="currentIndex === adminSidebarCurrentIndexes[adminNavGroups.ORGANIZATION]"
                [attr.data-e2e]="item.name"
                [target]="item.openInNewTab ? '_blank' : '_self'"
                (click)="item.isOutsideLink ? openOutsideLinkInNewTab(item.link) : onSidebarItemClick(item)"
              >
                <div class="icon-container fv-sidebar-icon">
                  <i phx-icon [phxIcon]="phxIconNames[item.name]"></i>
                </div>
                <span class="link-text fv-sidebar-text phx-web-type-body-medium" title="{{ item.label }}">{{ item.label }}</span>
                <span *ngIf="item.isAlphaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>alpha</span>
                <span *ngIf="item.isBetaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>beta</span>
                <span *ngIf="item.isNewTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>new</span>
                <phx-badge *ngIf="item.count" class="counter-badge" phxSize="small" [phxCount]="item.count"></phx-badge>
                <span *ngIf="item.showNotificationDot" class="ui tiny circular label counter"></span>
              </a>
            </span>
          </div>
        </div>
        <div *ngIf="adminNavItems[adminNavGroups.PRODUCTS]?.length">
          <div
            class="d-flex align-items-center title justify-space-between nav-group active"
            (click)="accordionStateChange(adminNavGroups.PRODUCTS)"
          >
            <span class="group-title" [title]="adminNavGroups.PRODUCTS">{{ adminNavGroupsTitles[adminNavGroups.PRODUCTS] }}</span>
            <phx-divider class="grey-80" phxMarginY="none"> </phx-divider>
            <i
              phx-icon
              [phxIcon]="chevronDownIcon"
              size="16"
              [ngClass]="{
                rotate180: adminSidebarStates[adminNavGroups.PRODUCTS],
                rotate0: !adminSidebarStates[adminNavGroups.PRODUCTS]
              }"
            ></i>
            <phx-divider class="grey-80" phxMarginY="none"></phx-divider>
          </div>
          <div
            class="content p-0-imp"
            [class.close]="!adminSidebarStates[adminNavGroups.PRODUCTS]"
            [class.open]="adminSidebarStates[adminNavGroups.PRODUCTS]"
            data-key="products"
          >
            <span
              *ngFor="let item of adminNavItems[adminNavGroups.PRODUCTS]; let currentIndex = index"
              phx-tooltip
              [phxContent]="item.label"
              phxPlacement="right"
              phxTooltipSize="small"
              [phxTrigger]="isSideBarMaximized || showPopover ? 'none' : 'hover'"
            >
              <a
                class="fv-item item"
                phx-tooltip
                phxPlacement="right"
                [phxShowCloseIcon]="true"
                [phxContent]="popoverTemplate"
                phxTooltipOverlayClassName="notification-popover"
                [phxTooltipMaxWidth]="268"
                [phxTrigger]="showPopover && item.name === popover?.key ? 'always' : 'none'"
                [phxIntent]="popover?.intent || 'positive'"
                (phxTooltipCloseIconClicked)="popoverDismissed()"
                [routerLink]="item.link"
                [class.active]="currentIndex === adminSidebarCurrentIndexes[adminNavGroups.PRODUCTS]"
                [attr.data-e2e]="item.name"
                [target]="item.openInNewTab ? '_blank' : '_self'"
                (click)="onSidebarItemClick(item)"
              >
                <div class="icon-container fv-sidebar-icon">
                  <i phx-icon [phxIcon]="phxIconNames[item.name]"></i>
                </div>
                <span class="link-text fv-sidebar-text phx-web-type-body-medium" title="{{ item.label }}">{{ item.label }}</span>
                <span *ngIf="item.isAlphaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>alpha</span>
                <span *ngIf="item.isBetaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>beta</span>
                <span *ngIf="item.isNewTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>new</span>
                <phx-badge *ngIf="item.count" class="counter-badge" phxSize="small" [phxCount]="item.count"></phx-badge>
                <span *ngIf="item.showNotificationDot" class="ui tiny circular label counter"></span>
              </a>
            </span>
          </div>
        </div>
        <div *ngIf="adminNavItems[adminNavGroups.PLATFORM]?.length">
          <div
            class="d-flex align-items-center title justify-space-between nav-group active"
            (click)="accordionStateChange(adminNavGroups.PLATFORM)"
          >
            <span class="group-title" [title]="adminNavGroups.PLATFORM">{{ adminNavGroupsTitles[adminNavGroups.PLATFORM] }}</span>
            <phx-divider class="grey-80" phxMarginY="none"></phx-divider>
            <i
              phx-icon
              [phxIcon]="chevronDownIcon"
              size="16"
              [ngClass]="{
                rotate180: adminSidebarStates[adminNavGroups.PLATFORM],
                rotate0: !adminSidebarStates[adminNavGroups.PLATFORM]
              }"
            ></i>
            <phx-divider class="grey-80" phxMarginY="none"></phx-divider>
          </div>
          <div
            class="content p-0-imp"
            [class.close]="!adminSidebarStates[adminNavGroups.PLATFORM]"
            [class.open]="adminSidebarStates[adminNavGroups.PLATFORM]"
            data-key="platform"
          >
            <span
              *ngFor="let item of adminNavItems[adminNavGroups.PLATFORM]; let currentIndex = index"
              phx-tooltip
              [phxContent]="item.label"
              phxPlacement="right"
              phxTooltipSize="small"
              [phxTrigger]="isSideBarMaximized || showPopover ? 'none' : 'hover'"
            >
              <a
                class="fv-item item"
                phx-tooltip
                phxPlacement="right"
                [phxShowCloseIcon]="true"
                [phxContent]="popoverTemplate"
                phxTooltipOverlayClassName="notification-popover"
                [phxTooltipMaxWidth]="268"
                [phxTrigger]="showPopover && item.name === popover?.key ? 'always' : 'none'"
                [phxIntent]="popover?.intent || 'positive'"
                (phxTooltipCloseIconClicked)="popoverDismissed()"
                [routerLink]="item.link"
                [class.active]="currentIndex === adminSidebarCurrentIndexes[adminNavGroups.PLATFORM]"
                [attr.data-e2e]="item.name"
                [target]="item.openInNewTab ? '_blank' : '_self'"
                (click)="onSidebarItemClick(item)"
              >
                <div class="icon-container fv-sidebar-icon">
                  <i phx-icon [phxIcon]="phxIconNames[item.name]"></i>
                </div>
                <span class="link-text fv-sidebar-text phx-web-type-body-medium" title="{{ item.label }}">{{ item.label }}</span>
                <span *ngIf="item.isAlphaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>alpha</span>
                <span *ngIf="item.isBetaTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>beta</span>
                <span *ngIf="item.isNewTag" class="new-feature phx-web-type-body-extra-small-emphasis" i18n>new</span>
                <phx-badge *ngIf="item.count" class="counter-badge" phxSize="small" [phxCount]="item.count"></phx-badge>
                <span *ngIf="item.showNotificationDot" class="ui tiny circular label counter-badge"></span>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="sidebarNav"
  class="bottom-nav ui secondary fluid vertical menu menu-container"
  [class.light-theme]="isLightTheme"
></div>

<portal *ngIf="sidebarNav" [portalHostSelector]="'.user-account-settings-placeholder'">
  <div class="admin-v2">
    <app-expansion-upsells-sidebar-upsell
      [isSideBarMaximized]="isSideBarMaximized"
      [isAdminSidebar]="isAdminSidebar"
      [(isUpsellVisible)]="isUpsellVisible"
    >
    </app-expansion-upsells-sidebar-upsell>
    <div class="bottom-nav-items">
      <dashboard-admin-switcher
        *ngIf="isDashboardAdminSwitcherEnabled"
        class="bottom-nav-item"
        [switchingLink]="sidebarNav.backLink.link"
        [isLightTheme]="isLightTheme"
      ></dashboard-admin-switcher>
      <ada-chatbot
        #adaChatbot
        *ngIf="isChatbotSingleClickUXEnabled"
        class="bottom-nav-item"
        [ngClass]="{'cursor-wait': !loadDeferComponents}"
        [isLightTheme]="isLightTheme"
        [disableClick]="!loadDeferComponents"
        (chatbotUnavailable)="chatbotUnavailable()"
      ></ada-chatbot>
      <support-menu *ngIf="!isChatbotSingleClickUXEnabled" class="bottom-nav-item" [isLightTheme]="isLightTheme"></support-menu>
      <notification-center
        *ngIf="!session.isDriver()"
        class="bottom-nav-item"
        [ngClass]="{'cursor-wait': !loadDeferComponents}"
        [isLightTheme]="isLightTheme"
        [disableClick]="!loadDeferComponents"
      ></notification-center>
      <avatar-dropdown class="bottom-nav-item" [isLightTheme]="isLightTheme"></avatar-dropdown>
    </div>
  </div>
</portal>
<portal [portalHostSelector]="'.expand-side-bar'"></portal>
<ng-template #popoverTemplate>
  <div class="phx-web-type-title-small">{{ popover?.header }}</div>
  <div 
    [class]="messageType === fleetCardsApplicationNudgeMessageType.linkBankAccount ? 'phx-web-type-body-medium mt-2 link' : 'phx-web-type-body-medium mt-2'"
    (click)="handlePlaidLinkClick()">
    {{popover?.content}}
  </div>
  <div *ngIf="popover?.subContent" class="phx-web-type-body-medium mt-2">{{popover?.subContent}}</div>
  <div id="buttons" class="d-flex gap-5 mt-8">
    <button
      *ngIf="popover?.primaryBtn"
      (click)="popoverPrimaryBtnClicked()"
      phx-button
      phxSize="small"
      phxButtonRole="primary"
      phxBackground="inverted"
    >
      {{ popover?.primaryBtn?.text }}
    </button>
    <button
      class="outline-btn"
      *ngIf="popover?.secondaryBtn"
      (click)="popoverSecondaryBtnClicked()"
      phx-button
      phxSize="small"
      phxButtonRole="secondary"
      phxBackground="inverted"
    >
      {{ popover?.secondaryBtn?.text }}
    </button>
  </div>
</ng-template>
